import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus, Play } from "lucide-react";
import { GHS } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const out = product.stock <= 0;

  const add = (e) => {
    e.preventDefault();
    addItem(product, 1);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.06 }}
    >
      <Link to={`/product/${product.product_id}`} data-testid={`product-card-${product.product_id}`}
        className="group block bg-white rounded-sm border border-brand/10 overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow] duration-300">
        <div className="relative aspect-square overflow-hidden bg-brand-surface">
          <img src={product.image} alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <span className="absolute top-3 left-3 bg-brand-bg/90 text-brand text-[10px] uppercase tracking-wider font-semibold px-2.5 py-1 rounded-full">
            {product.category}
          </span>
          {out && <span className="absolute top-3 right-3 bg-brand-terracotta text-white text-[10px] font-semibold px-2.5 py-1 rounded-full">Out of stock</span>}
          {product.video && (
            <span data-testid={`video-badge-${product.product_id}`}
              className="absolute bottom-3 left-3 flex items-center gap-1.5 bg-brand-bg/90 text-brand text-[10px] uppercase tracking-wider font-semibold px-2.5 py-1 rounded-full backdrop-blur-sm">
              <Play className="w-3 h-3 fill-brand" /> Watch how it's made
            </span>
          )}
        </div>
        <div className="p-4">
          <h3 className="font-display text-lg text-brand leading-tight">{product.name}</h3>
          <p className="text-xs text-brand-muted mt-1">{product.unit}</p>
          <div className="flex items-center justify-between mt-3">
            <span className="text-brand font-bold">{GHS(product.price)}</span>
            <button data-testid={`add-to-cart-${product.product_id}`} onClick={add} disabled={out}
              className="w-9 h-9 rounded-full bg-brand text-white flex items-center justify-center hover:bg-brand-hover transition-colors disabled:opacity-40">
              <Plus className="w-4 h-4" />
            </button>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
